import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_generation_graph_set_field_to_create_new_edge = (payload: FIELD__base = FIELD__base.CREATE_STUB()): PayloadAction<FIELD__base> => ({
  type: ENUM__redux_action.UI_GENERATION_GRAPH_SET_FIELD_TO_CREATE_NEW_EDGE,
  payload,
});

export function INIT_LOCAL__ui_generation_graph_set_field_to_create_new_edge(state: STATE__ui, action: PayloadAction<FIELD__base>) {
  state.g_graph__new_edge_field = action.payload.clone();
}
